import { styled } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
import { MuiTab } from '../../../../../modules/material';
import { TabProps } from './index';

export const StyledTab = styled(MuiTab)<TabProps>(({ theme }) => {
  return {
    color: theme.palette.neutral[600],
    padding: 'var(--payment-component-tab-padding)',
    borderRadius: 'var(--payment-component-tab-border-radius)',
    textTransform: 'none',
    maxWidth: '100%',

    [`&.${tabClasses.selected}`]: {
      color: theme.palette.neutral[800],
      backgroundColor: theme.palette.neutral[0],
    },

    [`&.${tabClasses.disabled}`]: {
      pointerEvents: 'auto',
      cursor: 'not-allowed',
    },

    [theme.breakpoints.up('md')]: {
      minHeight: 'initial',
      textAlign: 'left',
      maxWidth: 'none',
    },
  };
});
